import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"
import Container from "../components/Container"
import SubHeader from "../components/SubHeader"
import P from "../components/P"

const HorizontalContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  padding-left: 15%;
  padding-right: 15%;
  padding-top: 70px;
`

const PersonaImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 50px;
`
const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
`
const VerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const PersonaDescContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 370px;
  min-height: 330px;
  padding-top: 5px;
`

const Header = styled.h2`
  font-size: 30px;
  font-weight: bold;
  color: #000;
`

const H4 = styled.h4`
  font-size: 24px;
  font-weight: bold;
  color: #000;
`

const PersonasSection = () => {
  const data = useStaticQuery(graphql`
    query {
      alvina: file(relativePath: { eq: "Alvina2.png" }) {
        childImageSharp {
          fixed(width: 220, height: 220, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      khalid: file(relativePath: { eq: "Khalid3.png" }) {
        childImageSharp {
          fixed(width: 220, height: 220, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      gordon: file(relativePath: { eq: "Gordon2.jpg" }) {
        childImageSharp {
          fixed(width: 220, height: 220, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `)

  return (
    <>
      <Container noTop>
        <SubHeader>Personas</SubHeader>
        <P>
          By gathering data from Rose-Hulman students, we were able to come up
          with three personas that users of the Degree Planner website generally
          fall into. These are the highlights for each persona:
        </P>
      </Container>
      <HorizontalContainer>
        <VerContainer>
          <PersonaImageContainer>
            <Header>1. Incoming Freshman</Header>
            <Img
              style={{ borderRadius: "100%" }}
              fixed={data.alvina.childImageSharp.fixed}
            />
          </PersonaImageContainer>
          <PersonaImageContainer>
            <Header>2. Double Majoring</Header>
            <Img
              style={{ borderRadius: "100%" }}
              fixed={data.khalid.childImageSharp.fixed}
            />
          </PersonaImageContainer>
          <PersonaImageContainer>
            <Header>3. Switching Major</Header>
            <Img
              style={{ borderRadius: "100%" }}
              fixed={data.gordon.childImageSharp.fixed}
            />
          </PersonaImageContainer>
        </VerContainer>
        <VerContainer>
          <PersonaDescContainer>
            <H4>
              Alvina Lee
              <br />
              17-19 years old
            </H4>
            <P>
              They came to Rose-Hulman, without having much knowledge about the
              degree requirements, and are required to make a 4-year plan for
              their advisors.
            </P>
          </PersonaDescContainer>
          <PersonaDescContainer>
            <H4>
              Khalid Sena
              <br />
              17-22 years old
            </H4>
            <P>
              They are in Junior year and interested in other majors in addition
              to their original major and want to see if they can add double
              major or add more minors and still graduate in 4 years.
            </P>
          </PersonaDescContainer>
          <PersonaDescContainer>
            <H4>
              Gordon Phoon
              <br />
              18-21 years old
            </H4>
            <P>
              They finished up their Freshman year realizing they are interested
              more in another major. They do not have enough knowledge about the
              new major’s degree requirements. They want to verify if they can
              graduate in 4 years with the new major and how the courses taken
              in Freshman year counts toward the new major.
            </P>
          </PersonaDescContainer>
        </VerContainer>
      </HorizontalContainer>
    </>
  )
}

export default PersonasSection
